/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_TitleInputs */

const en_cancel_title = /** @type {(inputs: Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We're sorry to see you go`)
};

const de_cancel_title = /** @type {(inputs: Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es tut uns leid, dass du gehst`)
};

const fr_cancel_title = /** @type {(inputs: Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous sommes desoles de te voir partir`)
};

const es_cancel_title = /** @type {(inputs: Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lamentamos que te vayas`)
};

const it_cancel_title = /** @type {(inputs: Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ci dispiace vederti andare`)
};

const nl_cancel_title = /** @type {(inputs: Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jammer dat je vertrekt`)
};

const pl_cancel_title = /** @type {(inputs: Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przykro nam, ze odchodzisz`)
};

const fi_cancel_title = /** @type {(inputs: Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harmi etta lahdet`)
};

const da_cancel_title = /** @type {(inputs: Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi er kede af at se dig gå`)
};

const sv_cancel_title = /** @type {(inputs: Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi är ledsna att du går`)
};

/**
* | output |
* | --- |
* | "We're sorry to see you go" |
*
* @param {Cancel_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_title = /** @type {((inputs?: Cancel_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_title(inputs)
	if (locale === "fr") return fr_cancel_title(inputs)
	if (locale === "es") return es_cancel_title(inputs)
	if (locale === "it") return it_cancel_title(inputs)
	if (locale === "nl") return nl_cancel_title(inputs)
	if (locale === "pl") return pl_cancel_title(inputs)
	if (locale === "fi") return fi_cancel_title(inputs)
	if (locale === "da") return da_cancel_title(inputs)
	if (locale === "sv") return sv_cancel_title(inputs)
	return en_cancel_title(inputs)
});